<template>
  <div>
    <!-- Start Header Area -->
    <Header default-color="#c6c9d8">
      <img
          slot="logo"
          src="../../assets/images/layout/smile-logo-white.svg"
          class="logo-light"
          alt="Smile Magazine Logo"
          style="max-width: 13rem"
      />
      <img
          slot="logo-dark"
          src="../../assets/images/layout/smile-logo.svg"
          class="logo-dark"
          alt="Smile Magazine Logo"
      />
    </Header>
    <!-- End Header Area -->

    <!-- Start Breadcrump Area  -->
    <div
      class="rn-page-title-area pt--120 pb--190 bg_image"
      data-black-overlay="7"
      :style="{ backgroundImage: `url('${topImage}')`, backgroundSize: 'cover', backgroundPosition: 'center', transform: 'scale(1.0)' }"
    >
      <v-container>
        <v-row>
          <v-col cols="12">
            <div class="blog-single-page-title text-center pt--100">
              <h2 class="heading-title theme-gradient">{{ postTitle }}</h2>
              <ul class="blog-meta d-flex justify-center align-center position-relative">
                <li class="d-flex" v-for="(meta, i) in metaList" :key="i">
                  <span v-html="iconSvg(meta.icon)"></span>{{ meta.text }}
                </li>
              </ul>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <!-- End Breadcrump Area  -->

    <!-- Start Blog Details Area  -->
    <div class="rn-blog-details pt--110 pb--70 bg_color--1">
      <v-container>
        <v-row>
          <v-col cols="12">
            <div class="inner-wrapper">
              <div class="inner" v-for="(postElement, i) in postContent" :key="i">
                <div
                    v-if="postElement && postElement.src && postElement.type === 'image'"
                    class="thumbnail"
                >
                  <img
                      :src="postElement.src"
                      alt="Blog Images"
                  />
                </div>
                <div
                    class="video-wrapper position-relative mb--40"
                    v-if="postElement && postElement.src && postElement.type === 'video'"
                >
                  <CoolLightBox
                      :items="postContent"
                      :index="index"
                      @close="index = null"
                  >
                  </CoolLightBox>
                  <div class="thumbnail position-relative">
                    <div>
                      <img
                          class="w-100"
                          :src="postElement.thumb"
                          alt="About Images"
                      />
                      <a
                          @click="index = i"
                          class="video-popup position-top-center play__btn"
                      ><span class="play-icon"></span
                      ></a>
                    </div>
                  </div>
                </div>
                <p v-if="!postElement.type">
                  {{ postElement }}
                </p>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <!-- End Blog Details Area  -->

    <!-- Start Comment Form  -->
    <div class="blog-comment-form pb--120 bg_color--1">
      <v-container>
        <v-row>
          <v-col cols="12">
            <div class="inner">
              <h3 class="title mb--40 fontWeight500">Leave a Reply</h3>
              <ValidationObserver v-slot="{ handleSubmit }">
                <form @submit.prevent="handleSubmit(onSubmit)">
                  <v-row>
                    <v-col lg="6" md="12" cols="12">
                      <div class="rnform-group">
                        <ValidationProvider
                          name="name"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <label>
                            <input
                              type="text"
                              v-model="formData.name"
                              placeholder="Name"
                            />
                            <span class="inpur-error">{{ errors[0] }}</span>
                          </label>
                        </ValidationProvider>
                      </div>
                      <div class="rnform-group">
                        <ValidationProvider
                          name="email"
                          rules="required|email"
                          v-slot="{ errors }"
                        >
                          <label>
                            <input
                              type="text"
                              rules="required|email"
                              v-model="formData.email"
                              placeholder="Email"
                            />
                            <span class="inpur-error">{{ errors[0] }}</span>
                          </label>
                        </ValidationProvider>
                      </div>
                      <div class="rnform-group">
                        <ValidationProvider
                          name="website"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <label>
                            <input
                              type="text"
                              v-model="formData.subject"
                              placeholder="Website"
                            />
                            <span class="inpur-error">{{ errors[0] }}</span>
                          </label>
                        </ValidationProvider>
                      </div>
                    </v-col>
                    <v-col lg="6" md="12" cols="12">
                      <div class="rnform-group">
                        <ValidationProvider
                          name="comment"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <label>
                            <textarea
                              v-model="formData.message"
                              placeholder="Comment"
                            ></textarea>
                            <span class="inpur-error">{{ errors[0] }}</span>
                          </label>
                        </ValidationProvider>
                      </div>
                    </v-col>
                    <v-col cols="12">
                      <div class="blog-submit-btn">
                        <button
                          class="rn-button-style--2 btn_solid"
                          type="submit"
                          value="submit"
                        >
                          ENVIAR MENSAJE
                        </button>
                      </div>
                    </v-col>
                  </v-row>
                </form>
              </ValidationObserver>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <!-- End Comment Form  -->

    <!-- Start blog Area  -->
    <div class="rn-blog-area rn-section-gap bg_color--1">
      <v-container>
        <v-row>
          <v-col cols="12">
            <div class="section-title section-title--2 text-center">
              <h2 class="heading-title">Post relacionados</h2>
              <p>
                Desde smile magazine creemos sinceramente que alguno de estos post puede ser tambien de tu interes
              </p>
            </div>
          </v-col>
        </v-row>
        <!-- End .row -->
        <RelatedPosts v-if="relatedPosts" :relatedPosts="relatedPosts"/>
      </v-container>
    </div>
    <!-- Start blog Area  -->

    <Footer />
  </div>
</template>

<style>
.bg-image- {
  background-image: url('../../assets/images/contact/bg-image-1.jpg');
}
</style>

<script>
import Header from "../layout/header/HeaderOnePage.vue";
import Footer from "../../pages/layout/footer/Footer.vue";
import feather from "feather-icons";
import { ValidationObserver } from "vee-validate";
import { ValidationProvider } from "vee-validate/dist/vee-validate.full.esm";
import {container} from "@/main";
import {PostsService} from "@/pages/blog/posts.service";
import Blog from "@/components/blog/Blog.vue";
import RelatedPosts from "@/pages/blog/sections/RelatedPosts.vue";

export default {
  components: {
    RelatedPosts,
    Blog,
    Header,
    Footer,
    ValidationObserver,
    ValidationProvider,
  },
  async created() {
    this.postService = container.get(PostsService);
    this.topImage = require('../../assets/images/contact/bg-image-1.jpg');
    await this.renderPost();
  },
  data() {
    return {
      clearContent: null,
      formData: {
        name: "",
        email: "",
        subject: "",
        message: "",
      },
      items: [
        {
          thumb: require("../../assets/images/blog/bl-big-01.jpg"),
          src: "https://www.youtube.com/watch?v=ZOoVOfieAF8",
        },
      ],
      metaList: [],
      postContent: null,
      postTitle: null,
      index: null,
      relatedPosts: null,
      topImage: null,
    };
  },
  watch: {
    async '$route.params'(newParams, oldParams) {
      // Comprobar si el parámetro relevante (por ejemplo, ID del post) ha cambiado
      if (newParams.slug !== oldParams.slug) {
        await this.renderPost();
      }
    },
  },
  methods: {
    obtenerIdDeVideo(url) {
      const expresionRegular = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=|embed\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
      const coincidencia = url.match(expresionRegular);
      return coincidencia ? coincidencia[1] : null;
    },
    iconSvg(icon) {
      return feather.icons[icon].toSvg();
    },
    onSubmit() {
      console.log(this.formData);
    },
    clearHtmlText(text) {
      const p = document.createElement('p');
      p.innerHTML = text;
      return p.textContent;
    },
    splitTextInParagraphs(text) {
      return text.split('.\n');
    },
    insertMediaRandomly(paragraphs, medias) {
      medias.forEach(element => {
        const randomPosition = Math.floor(Math.random() * paragraphs.length);
        paragraphs.splice(randomPosition, 0, element); // Inserta el elemento multimedia
      });
      return paragraphs;
    },
    extractMedia(html) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const imagenes = Array.from(doc.querySelectorAll('img')).map(img => img.src);
      const videos = Array.from(doc.querySelectorAll('iframe')).map(iframe => iframe.src);
      const final = [];

      for(const image of imagenes) {
        this.topImage = image.src;
        final.push({
          src: image.src,
          type: 'image',
        });
      }

      for(const video of videos) {
        const id = this.obtenerIdDeVideo(video);
        const thumbnailUrl = `https://i.ytimg.com/vi_webp/${id}/sddefault.webp`;
        this.topImage = thumbnailUrl;
        final.push({
          src: video,
          type: 'video',
          thumb: thumbnailUrl
        });
      }

      return final;
    },
    async renderPost() {
      this.postService = container.get(PostsService);
      const postData = await this.postService.getPostDetailBySlug(this.$route.params.slug);
      this.relatedPosts = postData['jetpack-related-posts'] || [];
      const responses = await Promise.all([
        this.postService.getPostComments(postData.id),
        this.postService.getPostAuthor(postData.author),
        this.postService.getPostTags(postData.tags),
        this.postService.getPostMedia(postData.featured_media),
      ]);
      this.metaList = [
        {
          icon: "clock",
          text: postData.date,
        },
        {
          icon: "user",
          text: responses[1].name,
        },
        {
          icon: "message-circle",
          text: responses[0].length,
        },
      ];
      for (const tag of responses[2]) {
        this.metaList.push({
          icon: "hash",
          text: tag.slug,
        });
      }
      const medias = this.extractMedia(postData.content.rendered);
      this.postTitle = this.clearHtmlText(postData.title.rendered);
      let paragraphs = [];
      for(const paragraph of postData.content.rendered.split('<br />')) {
        if (paragraph) {
          const clearParagraph = this.clearHtmlText(paragraph);
          paragraphs.push(clearParagraph);
        }
      }
      paragraphs = this.insertMediaRandomly(paragraphs, medias);
      this.postContent = paragraphs;
      this.generateBrwosersMarkup();
    },
    generateBrwosersMarkup() {
      const articleMarkup = {
        "@context": "http://schema.org",
        "@type": "Article",
        "mainEntityOfPage": {
          "@type": "WebPage",
          "@id": this.$route.fullPath
        },
        "headline": this.postTitle,
        "image": {
          "@type": "ImageObject",
          "url": this.topImage,
          "height": 800, /* Altura en píxeles */
          "width": 1200 /* Ancho en píxeles */
        },
        "datePublished": this.metaList[0].text,
        "dateModified": this.metaList[0].text,
        "author": {
          "@type": "Person",
          "name": this.metaList[1].text
        },
        "publisher": {
          "@type": "Organization",
          "name": "Smile Magazine",
          "logo": {
            "@type": "ImageObject",
            "url": require('../../assets/images/layout/smile-logo.svg')
          }
        },
        "description": this.postTitle,
        "articleBody": this.clearContent
      };
      document.querySelector('#markup').textContent = JSON.stringify(articleMarkup, null, 2);
    }
  },
}
</script>
